import React, {useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import APIUrls from "../../services/APIUrls";
import { getAxiosResponse, handleError } from "../../services/authApiRoutes/APImethods";
import { ConditionalBlock } from "../../ConditionalBlock";
import Constants from "../../Constants";
import { useNavigate } from "react-router-dom";



export default function FinanceAdvanceFilter(prop) {
  const { t } = useTranslation();
  const translate = t;
  const navigate = useNavigate();
  const inputref = useRef(null);
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const [selectedSearchParameters, updateSelectedSearchParameters] = useState(prop.searchAdFilters);
  const [serviceProviderFilter, setServiceProviderFilter] = useState([]);
  const [departmentFilter, setDepartmentFilter] = useState([]);
  const [projectOwnerFilter, setProjectOwnerFilter] = useState([]);
  const [poNumberFilter, setPoNumberFilter] = useState([]);
  const [subscriberInvoiceNumberFilter, setSubscriberInvoiceNumberFilter] = useState([]);
  const [serviceProviderInvoiceNumberFilter, setServiceProviderInvoiceNumberFilter] = useState([]);

  const projectStatus = [
    {value: Constants.ADVANCE_FILTERS.closed, label: translate("advance_filters.closed")},
    {value: Constants.ADVANCE_FILTERS.outliers, label: translate("advance_filters.outliers")}
  ]

  const subscriberBillingStatus = [
    {value: Constants.SUBSCRIBER_INVOICE_STATUS.customer_invoice_no_action, label: translate("subscriber_invoice_status.CUSTOMER_INVOICE_NO_ACTION")},
    {value: Constants.SUBSCRIBER_INVOICE_STATUS.customer_invoice_sent, label: translate("subscriber_invoice_status.CUSTOMER_INVOICE_SENT")},
    {value: Constants.SUBSCRIBER_INVOICE_STATUS.customer_invoice_paid, label: translate("subscriber_invoice_status.CUSTOMER_INVOICE_PAID")}
  ]

  const serviceProviderBillingStatus = [
    {value: Constants.SERVICE_PROVIDER_INVOICE_STATUS.vendor_invoice_no_action, label: translate("service_provider_invoice_status.VENDOR_INVOICE_NO_ACTION")},
    {value: Constants.SERVICE_PROVIDER_INVOICE_STATUS.vendor_invoice_received, label: translate("service_provider_invoice_status.VENDOR_INVOICE_RECEIVED")},
    {value: Constants.SERVICE_PROVIDER_INVOICE_STATUS.vendor_invoice_paid, label: translate("service_provider_invoice_status.VENDOR_INVOICE_PAID")}
  ]

  useEffect(() => {
    getAxiosResponse(`${APIUrls.ADVANCED_SEARCH_FINANCE(prop.accountId)}`)
      .then((res) => {
        if (res.data.code === 200) {
          setServiceProviderFilter(res.data.data.vendor);
          setDepartmentFilter(res.data.data.departments)
          setProjectOwnerFilter(res.data.data.projectOwners);
          setPoNumberFilter(res.data.data.poNumbers);
          setSubscriberInvoiceNumberFilter(res.data.data.customerInvoiceNumbers);
          setServiceProviderInvoiceNumberFilter(res.data.data.vendorInvoiceNumbers);
        }
      }).catch((err) => {
        handleError(err);
      });
  }, []);


  function hideRightModel() {
    prop.setShowAdvanceFilter(false)
  }

  const handleOnApply = () => {
    prop.updateSearchAdFilters(selectedSearchParameters);
    hideRightModel();
    if(selectedSearchParameters.Project_ID) {
      navigate(`/finance/project/${selectedSearchParameters.Project_ID}`);
    }
  };


  const updateSelectedProjectId = (projectid) => {
    updateSelectedSearchParameters({ ...selectedSearchParameters, Project_ID: projectid });
  }

  const updateSelectedProjectStatus = (projectstatus) => {
    updateSelectedSearchParameters({ ...selectedSearchParameters, Project_Status: projectstatus });
  }
  const updateSelectedServiceProviderInvoiceStatus = (invoiceStatus) => {
    updateSelectedSearchParameters({ ...selectedSearchParameters, Service_Provider_Invoice_Status: invoiceStatus });
  }
  const updateSelectedVendor = (vendor) => {
    updateSelectedSearchParameters({ ...selectedSearchParameters, Service_Provider: vendor });
  }
  const updateSelectedSubscriberInvoiceStatus = (invoiceStatus) => {
    updateSelectedSearchParameters({ ...selectedSearchParameters, Subscriber_Invoice_Status: invoiceStatus });
  }

  const updateDepartmentStatus = (departmentStatus) => {
    updateSelectedSearchParameters({ ...selectedSearchParameters, Departments: departmentStatus});
  }

  const updateProjectOwnerStatus = (projectOwnerStatus) => {
    updateSelectedSearchParameters({ ...selectedSearchParameters, Project_Owner: projectOwnerStatus});
  }

  const updatePoNumberStatus = (poNumberStatus) => {
    updateSelectedSearchParameters({ ...selectedSearchParameters, Po_Number: poNumberStatus});
  }

  const updateServiceProviderInvoiceNumberStatus = (serviceProviderInvoiceNumberStatus) => {
    updateSelectedSearchParameters({ ...selectedSearchParameters, Service_Provider_Invoice_Number: serviceProviderInvoiceNumberStatus});
  }

  const updateSubscriberInvoiceNumberStatus = (subscriberInvoiceNumberStatus) => {
    updateSelectedSearchParameters({ ...selectedSearchParameters, Subscriber_Invoice_Number: subscriberInvoiceNumberStatus});
  }


  return (
    <div className="right-modal campaign-right-modal project-filters-modal" role="dialog" aria-labelledby="advanced-filters" aria-modal="true">
      <div className="modal-header flex">
        <div className="left flex-center" tabIndex={0}  >
          <strong id='advanced-filters'>{translate("project_listing.advanced_filters")}</strong>
        </div>

      </div>
      <div className="modal-content project-filter-content">
        <h4 aria-level={1}>{translate("project_listing.filter_by_column")}</h4>
        <div className="filter-selector">


          <div className="global-dropdown-block mar-bot14">
            <input
              placeholder={translate("project_listing.project_id")}
              onChange={(e) => {
                updateSelectedProjectId(e.target.value);
              }}
              ref={inputref}
              className="form-control-sm"
              value={selectedSearchParameters.projectId}
              type="number"
            ></input>
          </div>

          <div className="global-dropdown-block mar-bot14">
            <Select classNamePrefix='cw'
              styles={{
                option: (baseStyles, state) => ({
                  ...baseStyles,
                  color: aaaSelected ? "#000000" : "#1C233C",
                }),
              }}
              name="Service Provider"
              aria-label="Service Provider"
              placeholder={translate("project_listing.service_provider")}
              options={serviceProviderFilter}
              onChange={(value) => updateSelectedVendor(value)}
              value={serviceProviderFilter.filter(option => option.label === selectedSearchParameters.Service_Provider?.label)}
            ></Select>
          </div>



          <div className="global-dropdown-block mar-bot14">
            <Select classNamePrefix='cw'
              styles={{
                option: (baseStyles, state) => ({
                  ...baseStyles,
                  color: aaaSelected ? "#000000" : "#1C233C",
                }),
              }}
              name="Project Status"
              aria-label="Project Status"
              placeholder={translate("project_listing.project_status")}
              options={projectStatus}
              onChange={(value) => updateSelectedProjectStatus(value)}
              value={projectStatus.filter(option => option.label === selectedSearchParameters.Project_Status?.label)}
            ></Select>
          </div>

          <div className="global-dropdown-block mar-bot14">
            <Select classNamePrefix='cw'
              styles={{
                option: (baseStyles, state) => ({
                  ...baseStyles,
                  color: aaaSelected ? "#000000" : "#1C233C",
                }),
              }}
              name="subscriber Invoice Status"
              aria-label="subscriber Invoice Status"
              placeholder={translate("project_listing.service_provider_invoice_status")}
              options={serviceProviderBillingStatus}
              defaultValue={1}
              onChange={(value) => updateSelectedServiceProviderInvoiceStatus(value)}
              value={serviceProviderBillingStatus.filter(option => option.label === selectedSearchParameters.Service_Provider_Invoice_Status?.label)}
            ></Select>
          </div>

          <div className="global-dropdown-block mar-bot14">
            <Select classNamePrefix='cw'
              styles={{
                option: (baseStyles, state) => ({
                  ...baseStyles,
                  color: aaaSelected ? "#000000" : "#1C233C",
                }),
              }}
              name="subscriber Invoice Status"
              aria-label="subscriber Invoice Status"
              placeholder={translate("project_listing.subscriber_invoice_status")}
              options={subscriberBillingStatus}
              defaultValue={1}
              onChange={(value) => updateSelectedSubscriberInvoiceStatus(value)}
              value={subscriberBillingStatus.filter(option => option.label === selectedSearchParameters.Subscriber_Invoice_Status?.label)}
            ></Select>
          </div>

          <ConditionalBlock condition={prop.reportsAdvanceFilter}>
            <div className="global-dropdown-block mar-bot14">
              <Select classNamePrefix='cw'
                styles={{
                  option: (baseStyles, state) => ({
                    ...baseStyles,
                    color: aaaSelected ? "#000000" : "#1C233C",
                  }),
                }}
                name="Department"
                aria-label="Department"
                placeholder="Department"
                options={departmentFilter}
                onChange={(value) => updateDepartmentStatus(value)}
                value={departmentFilter?.filter(option => option.label === selectedSearchParameters.Departments?.label)}
              ></Select>
            </div>
            
            <div className="global-dropdown-block mar-bot14">
              <Select classNamePrefix='cw'
                styles={{
                  option: (baseStyles, state) => ({
                    ...baseStyles,
                    color: aaaSelected ? "#000000" : "#1C233C",
                  }),
                }}
                name="Project Owner"
                aria-label="Project Owner"
                placeholder="Project Owner"
                options={projectOwnerFilter}
                onChange={(value) => updateProjectOwnerStatus(value)}
                value={projectOwnerFilter?.filter(option => option.label === selectedSearchParameters.Project_Owner?.label)}
              ></Select>
            </div>

            <div className="global-dropdown-block mar-bot14">
              <Select classNamePrefix='cw'
                styles={{
                  option: (baseStyles, state) => ({
                    ...baseStyles,
                    color: aaaSelected ? "#000000" : "#1C233C",
                  }),
                }}
                name="Subscriber Invoice Number"
                aria-label="subscriber Invoice Number"
                placeholder="Subscriber Invoice Number"
                options={subscriberInvoiceNumberFilter}
                onChange={(value) => updateSubscriberInvoiceNumberStatus(value)}
                value={subscriberInvoiceNumberFilter?.filter(option => option.label === selectedSearchParameters.Subscriber_Invoice_Number?.label)}
              ></Select>
            </div>

            <div className="global-dropdown-block mar-bot14">
              <Select classNamePrefix='cw'
                styles={{
                  option: (baseStyles, state) => ({
                    ...baseStyles,
                    color: aaaSelected ? "#000000" : "#1C233C",
                  }),
                }}
                name="Service Provider Invoice Number"
                aria-label="Service Provider Invoice Number"
                placeholder="Service Provider Invoice Number"
                options={serviceProviderInvoiceNumberFilter}
                onChange={(value) => updateServiceProviderInvoiceNumberStatus(value)}
                value={serviceProviderInvoiceNumberFilter?.filter(option => option.label === selectedSearchParameters.Service_Provider_Invoice_Number?.label)}
              ></Select>
            </div>

            <div className="global-dropdown-block mar-bot14">
              <Select classNamePrefix='cw'
                styles={{
                  option: (baseStyles, state) => ({
                    ...baseStyles,
                    color: aaaSelected ? "#000000" : "#1C233C",
                  }),
                }}
                name="PO Number"
                aria-label="PO Number"
                placeholder="PO Number"
                options={poNumberFilter}
                onChange={(value) => updatePoNumberStatus(value)}
                value={poNumberFilter?.filter(option => option.label === selectedSearchParameters.Po_Number?.label)}
              ></Select>
            </div>
          </ConditionalBlock>

          <div className="button-group flex">
            <button className="btn default-btn first-focus" onClick={hideRightModel}>
              {translate("project_listing.cancel")}
            </button>
            <button className="btn" id='apply-id' onClick={handleOnApply}>
              {translate("project_listing.apply")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
